import { PropertyWizardContext } from 'context/Context';
import { Form, Formik } from 'formik';
import lodash from 'lodash';
import { useContext, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateByUserId } from 'redux/realEstateSlice';
import { OperationAndPropertieSchema } from '../../validations/propertiesValidation';
import { PropertyData } from './components/PropertyData';
import { ShareData } from './components/ShareData';
import { CheckErrors } from 'utils/CheckErrors';
//import { OwnerData } from './components/OwnerData';

export const operaciones = [
  { name: 'Venta', value: '1', label: 'Venta' },
  { name: 'Alquiler', value: '2', label: 'Alquiler' },
  { name: 'Temporario', value: '3', label: 'Temporario' }
];

const tiposPropiedades = [
  { name: 'Departamento', value: 1, hasSubtype: true },
  { name: 'Casa', value: 2, hasSubtype: true },
  { name: 'PH', value: 3, hasSubtype: false },
  { name: 'Cochera', value: 4, hasSubtype: false },
  { name: 'Consultorio', value: 5, hasSubtype: false },
  { name: 'Fondo de comercio', value: 6, hasSubtype: false },
  { name: 'Local Comercial', value: 7, hasSubtype: true },
  { name: 'Oficina Comercial', value: 8, hasSubtype: false },
  { name: 'Bodega/Galpón/Depósito', value: 9, hasSubtype: true },
  { name: 'Terreno', value: 10, hasSubtype: false },
  { name: 'Hotel', value: 11, hasSubtype: false },
  { name: 'Edificio', value: 12, hasSubtype: false },
  { name: 'Bóveda/Nicho/Parcela', value: 13, hasSubtype: true }
];

export const tiposPropiedadesConSubtipos = tiposPropiedades
  .filter(tipo => tipo.hasSubtype)
  .map(tipo => tipo.value);

const OperacionYPropiedad = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef } = useContext(
    PropertyWizardContext
  );

  const dispatch = useDispatch();

  const userLogged = useSelector(state => state.login.currentUser);
  const realEstate = useSelector(state => state.realEstate.realEstate);

  useEffect(() => {
    userLogged?.id && dispatch(getRealEstateByUserId(userLogged.id));
  }, [userLogged]);

  const initialValues = {
    real_estate_id: data.real_estate_id || realEstate.id,
    branch_office_id: data.branch_office_id || '',
    operation_type: data.operation_type || '',
    property_type: data.property_type || '',
    sub_property_type: data.sub_property_type || '',
    title: data.title || '',
    share: data.share?.percent ? String(data.share.percent) : ''
    // owner: {
    //   name: data.owner?.name || '',
    //   phoneNumber: data.owner?.phoneNumber || '',
    //   email: data.owner?.email || '',
    //   observations: data.owner?.observations || ''
    // }
  };

  // const HandleClick = errors => {
  //   if (Object.keys(errors).length) {
  //     const errorsMapped = Object.keys(errors).map(field =>
  //       errorMsgGenerator(errors[field], errorTitles[field])
  //     );

  //     const message = (
  //       <div>
  //         <p>Corrija los siguientes errores para poder continuar:</p>
  //         {errorsMapped.map((error, i) => (
  //           <p key={i}>{error}</p>
  //         ))}
  //       </div>
  //     );

  //     messageHandler('error', message);
  //   }
  // };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={OperationAndPropertieSchema}
      onSubmit={values => {
        handleSubmit(values, lodash.isEqual(values, initialValues));
      }}
      validateOnChange
      validateOnBlur
    >
      {({ errors, touched, values, setValues }) => {
        useEffect(() => {
          setValues(prev => ({
            ...prev,
            real_estate_id: data.real_estate_id || realEstate.id
          }));
        }, [realEstate]);

        useEffect(() => {
          setStepStatus(prev => ({
            ...prev,
            ...values
          }));
        }, [values]);

        return (
          <>
            <Form
              className="mb-3"
              onKeyDown={e => {
                e.key === 'Enter' && e.preventDefault();
              }}
            >
              <Row>
                <Col xs={12} className="px-3">
                  <legend>
                    <FiCheck /> Describa la propiedad y operación
                    correspondiente.
                  </legend>

                  <Row className="g-3 mb-4">
                    <PropertyData
                      data={data}
                      errors={errors}
                      touched={touched}
                      setValues={setValues}
                      values={values}
                      realEstate={realEstate}
                    />
                  </Row>

                  <Row>
                    <Col>
                      <ShareData />
                    </Col>
                  </Row>
                </Col>

                {/*<Col xs={6} className="bg-light p-4">
                  <Row className="g-3">
                    <OwnerData errors={errors} touched={touched} />
                  </Row>
                </Col>*/}
              </Row>

              <button
                onClick={() => CheckErrors(errors)}
                hidden
                ref={yupSubmitRef}
              ></button>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default OperacionYPropiedad;
